import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入样式文件
import './style/index.less'

//引入viewUI
// import ViewUI from 'view-design'
// import 'view-design/dist/styles/iview.css'
//
// Vue.use(ViewUI)

//导入iview的js文件
import iView from 'iview'
//导入iview的css文件
import 'iview/dist/styles/iview.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 需要use的插件直接添加到该数组中即可
const useList = [
  iView,
  ElementUI,
]

Vue.config.productionTip = false
// 批量执行app.use
for (let u in useList) {
  Vue.use(useList[u])
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
